// src/pages/coach/sessions/AttendanceView.jsx
import React from "react";
import AttendanceView from "../../../components/attendance/AttendanceView";

const CoachAttendanceView = () => {
    return <AttendanceView role="COACH" />;
};

export default CoachAttendanceView;